import { UseMutationResult, useMutation } from "@tanstack/react-query";
import { Methods } from "../../constants/CommonConstants";
import Api from "../axios";
import { EndPoints } from "../endPoints";
import { handleApiResponseErrors } from "../HandleAPIResponseErrors";
import { GeneralResponse } from "../../../types/api";
import {
  ICreatePasswordRequest,
  ICreatePasswordResponse,
} from "../../../types/apis/auth-apis";

export const CreatePassword = async (
  payload: ICreatePasswordRequest,
): Promise<GeneralResponse> => {
  try {
    const response = await Api<any, GeneralResponse<ICreatePasswordResponse>>({
      method: Methods.POST,
      endpoint: EndPoints.createPassword,
      body: payload,
    });
    handleApiResponseErrors(response, "validation_error");
    return response;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export const useCreatePassword = (options = {}) => {
  const mutation: UseMutationResult<
    GeneralResponse,
    Error,
    ICreatePasswordRequest
  > = useMutation({
    mutationFn: CreatePassword,
    ...options,
  });
  return {
    data: mutation.data,
    error: mutation.error,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    mutate: mutation.mutate,
    reset: mutation.reset,
    status: mutation.status,
  };
};
